<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
      >
        <v-card>
          <v-card-title />
          <v-card-text class="text-center">
            <span v-html="$t('lbl.adblockHelp')" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
      >
        <v-card>
          <v-card-title />
          <v-row>
            <v-col cols="8">
              <v-card-title class="justify-center">
                {{ $t("lbl.adblock") }}
              </v-card-title>
              <v-card-subtitle class="text-center">
                {{ $t("lbl.on") }} / {{ $t("lbl.off") }}
              </v-card-subtitle>
            </v-col>
            <v-col cols="4">
              <v-card-text>
                <v-switch
                  v-model="active"
                  :disabled="disable"
                  @click="save()"
                />
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="auto"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
      >
        <v-card>
          <v-tabs v-model="tabViews">
            <v-tab
              v-for="(item, i) in views"
              :key="i"
            >
              {{
                i === 0 ? $t('lbl.default') : (item.name ? item.name : $t('lbl.list'))
              }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabViews">
            <v-tab-item
              v-for="(item, i) in views"
              :key="i"
            >
              <v-row :class="rowStyle">
                <v-col
                  :class="colStyle"
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-text-field
                    v-if="i === 0"
                    hide-details
                    readonly
                    :label="$t('lbl.name')"
                    :value="$t('lbl.default')"
                  />
                  <v-text-field
                    v-else
                    hide-details
                    :label="$t('lbl.name')"
                    v-model="item.name"
                  />
                </v-col>
                <v-col
                  :class="colStyle"
                  class="px-0"
                  cols="12"
                  sm="2"
                >
                  <v-switch
                    color="primary"
                    hide-details
                    v-model="isDefault"
                    :disabled="disable"
                    :label="isDefault ? $t('lbl.all') : $t('lbl.custom')"
                    @click="toggleDefault(item)"
                  />
                </v-col>
              </v-row>
              <v-simple-table>
                <template v-slot:default>
                  <thead />
                  <tbody>
                    <tr
                      v-for="item in item.lists"
                      :key="item.no"
                    >
                      <td>{{ $t(`lbl.${item.name}`) }}</td>
                      <v-spacer />
                      <td class="text-right px-0">
                        <v-switch
                          color="info"
                          hide-details
                          v-model="item.state"
                          :disabled="disable || isDefault"
                        />
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-tab-item>
          </v-tabs-items>
          <v-divider class="mb-2" />
          <v-divider />
          <v-tabs v-model="tabBwLists">
            <v-tab
              v-for="({ label }, i) in bwLists"
              :key="i"
            >
              {{ $t(`lbl.${label}`) }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabBwLists">
            <v-tab-item
              v-for="({ name, black }, j) in bwLists"
              :key="j"
            >
              <v-form
                :ref="name"
                v-model="valid"
                @submit.prevent="addUrl(black, name, j)"
              >
                <v-card-text class="d-flex align-center">
                  <v-text-field
                    v-if="black"
                    hide-details
                    :label="$t('lbl.url')"
                    v-model="blackUrl"
                    :rules="formRules.urlRules"
                    class="mr-2"
                  />
                  <v-text-field
                    v-else
                    hide-details
                    :label="$t('lbl.url')"
                    v-model="whiteUrl"
                    :rules="formRules.urlRules"
                    class="mr-2"
                  />
                  <v-btn
                    color="blue darken-1"
                    text
                    :disabled="!valid"
                    @click="addUrl(black, name)"
                  >
                    {{ $t("lbl.add") }}
                  </v-btn>
                </v-card-text>
              </v-form>
              <v-simple-table>
                <template v-slot:default>
                  <thead />
                  <tbody>
                    <tr
                      v-for="(item, index) in black ? blackUrls : whiteUrls"
                      :key="index"
                    >
                      <td>{{ item }}</td>
                      <td class="text-right">
                        <v-btn
                          large
                          icon
                          :disabled="disable"
                          @click="deleteUrl(black, index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-tab-item>
          </v-tabs-items>
          <v-divider class="mb-2" />
          <template v-if="urlError">
            <v-card-text class="py-0">
              <v-text-field
                background-color="warning"
                outlined
                hide-details
                readonly
                dense
                :value="$t('error.adlistUrl')"
              />
            </v-card-text>
          </template>
          <template v-if="updateInfo">
            <v-divider class="mb-2" />
            <v-card-text class="py-0">
              <v-textarea
                background-color="warning"
                outlined
                hide-details
                readonly
                dense
                no-resize
                auto-grow
                :value="updateInfo"
              />
            </v-card-text>
          </template>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              text
              :disabled="disable || checkViews(false)"
              @click="save(true)"
            >{{ $t("lbl.save") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { url } from "../common/validation";
import rx from "../common/regex";

// eslint-disable-next-line import/no-named-as-default-member
const { domain, url: Url } = rx;

export default {
  data: () => ({
    disable: false,
    active: false,
    valid: true,
    tabViews: null,
    tabBwLists: null,
    views: [],
    blackUrls: [],
    whiteUrls: [],
    blackUrl: "",
    whiteUrl: "",
    urlError: false,
    updateInfo: "",
    isDefault: false,
    bwLists: [
      {
        black: true,
        name: "black",
        label: "blackUrls",
      },
      {
        black: false,
        name: "white",
        label: "whiteUrls",
      },
    ],
    formRules: {
      urlRules: [url],
    },
  }),
  created() {
    this.initialize();
  },
  computed: {
    rowStyle() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "ma-4 py-0";
        default:
          return "ma-1";
      }
    },
    colStyle() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "pa-0";
        default:
          return "";
      }
    },
  },
  watch: {
    tabViews(val) {
      if (Number.isInteger(val)) {
        this.setDefault();
      }
    },
    blackUrl(val) {
      if (val && domain.test(val)) {
        this.blackUrl = val.match(domain).at(1);
      }
    },
    whiteUrl(val) {
      if (val && domain.test(val)) {
        this.whiteUrl = val.match(domain).at(1);
      }
    },
  },
  methods: {
    ...mapActions("adblock", ["getState", "updateState"]),

    initialize() {
      this.getState()
        .then((result) => {
          const {
            active, views, blackUrls, whiteUrls,
          } = result;
          this.active = active;
          this.views = this.getViewsTable(views);
          this.blackUrls = blackUrls;
          this.whiteUrls = whiteUrls;
        })
        .catch((error) => {
          this.$toasted.error(this.getMessageText(error.message));
        });
    },

    save(isLists) {
      this.disable = true;
      const { active, blackUrls, whiteUrls } = this;
      const data = active
        ? {
          active,
          views: this.getViewsData(),
          blackUrls,
          whiteUrls,
        }
        : { active };
      this.updateState(data)
        .then((result) => {
          this.initialize();
          this.setUpdateInfo(result);
          const message = isLists
            ? this.$t("msg.save", { item: this.$t("lbl.blockLists") })
            : this.$t(result.active ? "msg.on" : "msg.off", {
              item: this.$t("lbl.adblock"),
            });
          this.$toasted.success(message);
        })
        .catch((error) => {
          this.$toasted.error(this.getMessageText(error.message));
        })
        .finally(() => {
          this.disable = false;
        });
    },

    addUrl(black) {
      if (black) {
        if (this.blackUrl && !this.checkUrl(this.blackUrl)) {
          this.blackUrls.push(this.blackUrl);
          this.blackUrl = "";
          this.$refs.black[0].reset();
        }
      } else if (this.whiteUrl && !this.checkUrl(this.whiteUrl)) {
        this.whiteUrls.push(this.whiteUrl);
        this.whiteUrl = "";
        this.$refs.white[0].reset();
      }
    },

    checkUrl(listUrl) {
      if (!Url.test(listUrl)) {
        return true;
      }
      const listUrls = [...this.blackUrls, ...this.whiteUrls];
      this.urlError = listUrls.includes(listUrl);
      return this.urlError;
    },

    deleteUrl(black, index) {
      if (black) {
        this.blackUrls.splice(index, 1);
      } else {
        this.whiteUrls.splice(index, 1);
      }
    },

    getViewsTable(views) {
      return views.map((view) => {
        const { lists, ...data } = view;
        const listsTable = this.getListsTable(lists);
        return {
          ...data,
          lists: listsTable,
        };
      });
    },

    getListsTable(lists) {
      const result = Object.entries(lists).map((list, no) => {
        const [name, state] = list;
        return { no: no + 1, name, state };
      });
      return result;
    },

    getViewsData() {
      return this.views.map((view) => {
        const { lists, active, ...data } = view;
        const result = {};
        lists.forEach((list) => {
          result[list.name] = list.state;
        });
        return { ...data, lists: result };
      });
    },

    toggleDefault(view) {
      if (this.isDefault) {
        view.lists.forEach((list) => {
          list.state = true;
        });
      }
    },

    setDefault() {
      this.isDefault = this.checkViews(true);
    },

    checkViews(allOrNone) {
      const view = this.views[this.tabViews];
      if (view) {
        return Object.values(view.lists).every((list) => (allOrNone ? list.state : !list.state));
      }
      return false;
    },

    setUpdateInfo(data) {
      const {
        total, online, offline, success, fail, offlines, fails,
      } = data;

      let message = this.$t("msg.adblock", {
        total,
        online,
        offline,
        success,
        fail,
      });
      if (offlines.length) {
        message = `${message}\n${this.$t("lbl.offline")}: ${offlines.join(", ")}`;
      }
      if (fails.length) {
        message = `${message}\n${this.$t("lbl.fail")}: ${fails.join(", ")}`;
      }
      this.updateInfo = message;
    },
  },
};
</script>

<style scoped>
.label-text >>> .v-input__slot::before {
  border-style: none !important;
}
</style>
